export default __webpack_public_path__ + "static/media/restaurant.c05d1a36.svg";